import { injected } from 'wagmi/connectors';

// Using a placeholder icon URL for now
const phantomIcon = 'https://explorer-api.walletconnect.com/v3/logo/md/b6ec7b81-bb4f-427d-e290-7631e6e50d00?projectId=34357d3c125c2bcf2ce2bc3309d98715';

export const phantomConnector = () => {
    const c = injected({
        target: 'phantom',
        // @ts-ignore
        shimDisconnect: true,
    });

    return (ctx: any) => {
        const connector = c(ctx);
        
return {
            ...connector,
            getProvider: () => connector.getProvider(),
            id: 'phantom',
            name: 'Phantom',
            icon: phantomIcon,
            getWalletConnectDeeplink: null,
            getQrCode: () => null,
            // @ts-ignore
            isAuthorized: async () => {
                if (typeof window !== 'undefined' && !((window as any).phantom?.ethereum)) {
                    return false;
                }
                
return connector.isAuthorized();
            },
            get installed() {
                return typeof window !== 'undefined' && !!((window as any).phantom?.ethereum);
            },
            get suggested() {
                return false;
            },
            extension: {
                instructions: {
                    learnMoreUrl: 'https://phantom.app/',
                    steps: [],
                },
            },
            downloadUrls: {
                get download() {
                    if (typeof window === 'undefined')
                        return 'https://phantom.app/download';

                    const isMobile = /iPhone|iPad|iPod|Android/i.test(
                        window.navigator.userAgent,
                    );
                    
                    if (isMobile) {
                         // Phantom Deep Link: https://phantom.app/ul/browse/<encoded_url>?ref=<ref_url>
                         return `https://phantom.app/ul/browse/${encodeURIComponent(window.location.href)}?ref=${encodeURIComponent(window.location.origin)}`;
                    }

                    return 'https://phantom.app/download';
                },
            },
        };
    };
};
